"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CSwitch = _interopRequireDefault(require("01_core/components/materials/CSwitch"));
var _ResourceHtml = _interopRequireDefault(require("01_core/components/materials/ResourceHtml"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _openSSO = require("01_core/logics/openSSO");
var _coreConditionActions = require("01_core/reducers/coreConditionActions");
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _CRadarChart = _interopRequireDefault(require("32_kansa/common/components/materials/CRadarChart"));
var _KansaTgtJigyoBasicInfo = _interopRequireDefault(require("32_kansa/common/components/materials/KansaTgtJigyoBasicInfo"));
var _moment = _interopRequireDefault(require("moment"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _kansaResultActions = require("../kansaResult/kansaResultActions");
var _kansaProgressActions = require("../progress/kansaProgressActions");
var _FollowupList = _interopRequireDefault(require("./components/FollowupList"));
var _KakuninjikoList = _interopRequireDefault(require("./components/KakuninjikoList"));
var _KansaKekkaJissiDate = _interopRequireDefault(require("./components/KansaKekkaJissiDate"));
var _KansaKekkaJissiPlace = _interopRequireDefault(require("./components/KansaKekkaJissiPlace"));
var _KansaKekkaSokatsu = _interopRequireDefault(require("./components/KansaKekkaSokatsu"));
var _RegisterReportInfo = _interopRequireDefault(require("./components/RegisterReportInfo"));
var _SeijukudoComment = _interopRequireDefault(require("./components/SeijukudoComment"));
var _ShoninDate = _interopRequireDefault(require("./components/ShoninDate"));
var _ShoninshaName = _interopRequireDefault(require("./components/ShoninshaName"));
var _SogoHyoka = _interopRequireDefault(require("./components/SogoHyoka"));
var _kansaResultRegisterActions = require("./kansaResultRegisterActions");
var Yup = _interopRequireWildcard(require("yup"));
var _useRHFForm = require("01_core/validation/useRHFForm");
var _validationHelpers = require("01_core/validation/validationHelpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 監査結果登録画面
 */
function KansaRegisterEntry(props) {
  var _errors$shoninDate, _errors$shoninshaNm, _errors$sogohyoka, _errors$naibukansaJis, _errors$naibukansaJis2, _errors$sokatsu, _errors$kansabumonCom;
  const {
    intl,
    callAPI,
    goMain,
    openConfirm,
    openInfoBar,
    setDirty,
    setEntries,
    setInitEntry,
    setkansaTgtJigyoBasicInfo,
    setSeijukudo,
    setContent,
    setRegisterDt,
    setMailErrMsg,
    overridePreviousEntries,
    changeBunruiCd,
    changeHakkenjiko,
    kansaInfo,
    kansaTgtJigyoBasicInfo,
    entries,
    followupList,
    listState,
    goodpointList,
    kaizenList,
    futekigoList,
    seijukudo,
    dispFlg,
    mailFlg,
    gyomuCd,
    isProgress,
    goProgressMain,
    returnBtn,
    getCodeName,
    upd,
    setDispFlg,
    getCodeItems,
    setFollowupList,
    setGoodpointList,
    setkaizenList,
    setFutekigoList
  } = props;
  const [isCustomCheck, setIsCustomCheck] = (0, _react.useState)(true);
  const [procKbn, setProcKbn] = (0, _react.useState)(_kansaResultRegisterActions.PROC_KBN.REGISTER);
  const [zennendoSimpleFlg, setZennendoSimpleFlg] = (0, _react.useState)('');
  const [zennendoKansakekkaCreStsCd, setZennendoKansakekkaCreStsCd] = (0, _react.useState)('');
  const [maxPoints, setMaxPoints] = (0, _react.useState)(0);
  const [ansDataError, setAnsDataError] = (0, _react.useState)(false);
  const scrolledRef = (0, _react.useRef)(false);
  const loadedRef = (0, _react.useRef)(false);

  /**
   * 成熟度差分あり
   */
  const changeComment = (0, _react.useCallback)(data => {
    openConfirm(intl.formatMessage({
      id: _labelConsts.LABEL.CORE_CONFIRM
    }), /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
      id: _labelConsts.LABEL.KANSA_RESULT_SEIJUKUDO_CHECK
    }), () => {
      setSeijukudo(data.seijukudoAns);
      setInitEntry('kansabumonComment')(data.kansabumonCommentAns === null ? '' : data.kansabumonCommentAns);
    });
  }, [openConfirm, intl, setSeijukudo, setInitEntry]);

  /**
   * 監査回答時情報（確認事項、成熟度評価）取得失敗
   */
  const dataErrorMessage = (0, _react.useCallback)(() => {
    openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_ANSDATA_NULL_CHECK
    }));
  }, [openInfoBar, intl]);
  (0, _react.useEffect)(() => {
    // 初期ロードは一度だけ（登録押下などで再評価されても再実行しない）
    if (loadedRef.current) {
      return;
    }
    const run = async () => {
      const sendData = {
        kansaTgtNendo: kansaInfo.kansaTgtNendo,
        kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId
      };
      try {
        // 監査対象基本情報取得（完了後に後続を実行）
        const basicRes = await callAPI(_APIs.KANSA_TGT_JIGYO_BASIC, sendData);
        if (basicRes.status === _APIs.STATUS.SUCCESS) {
          const info = basicRes.data;
          if (info) {
            setkansaTgtJigyoBasicInfo(info);
            if (_CodeConsts.CODE.KANSA_HYOKA_STS.CODE_3 === info.kansakekkaCreStsCd) {
              setDispFlg(false);
            } else {
              setDispFlg(true);
              setInitEntry('reportDate')((0, _moment.default)().format('YYYY/MM/DD'));
              setInitEntry('reportDestNm')(info.hikansaSekinishaNm);
            }
            if (info.zennendoKansaTgtNendo && info.zennendoKansaTgtJigyoId) {
              const sendDataZ = {
                kansaTgtNendo: info.zennendoKansaTgtNendo,
                kansaTgtJigyoId: info.zennendoKansaTgtJigyoId
              };
              try {
                const respZ = await callAPI(_APIs.KANSA_TGT_JIGYO_BASIC, sendDataZ);
                if (respZ.status === _APIs.STATUS.SUCCESS) {
                  const prev = respZ.data;
                  if (prev) {
                    setZennendoSimpleFlg(prev.simpleFlg);
                    setZennendoKansakekkaCreStsCd(prev.kansakekkaCreStsCd);
                  } else {
                    setZennendoSimpleFlg('');
                    setZennendoKansakekkaCreStsCd('');
                  }
                }
              } catch (e) {
                if ((e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.UNMOUNTED || (e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.CALLING) {
                  // no-op
                } else {
                  throw e;
                }
              }
            }
          }
        }

        // 確認事項一覧取得
        const kakuninRes = await callAPI(_APIs.KANSA_RESULT_KAKUNINJIKO, sendData);
        if (kakuninRes.status === _APIs.STATUS.SUCCESS) {
          if (kakuninRes.data !== null) {
            setFollowupList(kakuninRes.data.followupList);
            setGoodpointList(kakuninRes.data.goodpointList);
            setkaizenList(kakuninRes.data.kaizenList);
            setFutekigoList(kakuninRes.data.futekigoList);
            setMaxPoints(kakuninRes.data.maxPoints);
          } else {
            setAnsDataError(true);
            dataErrorMessage();
          }
        } else {
          setAnsDataError(true);
          dataErrorMessage();
        }
        const sendDataKekka = {
          kansaTgtNendo: kansaInfo.kansaTgtNendo,
          kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId,
          gyomuNaiyo: gyomuCd
        };

        // 更新／新規の初期値取得（基本情報取得後に実行）
        if (upd) {
          const updRes = await callAPI(_APIs.KANSA_RESULT_UPDATE_SEARCH, sendDataKekka);
          if (updRes.status === _APIs.STATUS.SUCCESS) {
            if (updRes.data !== null) {
              var _basicRes$data$kansak, _basicRes$data;
              setSeijukudo(updRes.data.seijukudoAns);
              setEntries(updRes.data);
              if (_CodeConsts.CODE.KANSA_RSLT_STS.CODE_3 !== ((_basicRes$data$kansak = basicRes === null || basicRes === void 0 || (_basicRes$data = basicRes.data) === null || _basicRes$data === void 0 ? void 0 : _basicRes$data.kansakekkaCreStsCd) !== null && _basicRes$data$kansak !== void 0 ? _basicRes$data$kansak : _CodeConsts.CODE.KANSA_RSLT_STS.CODE_1)) {
                var _basicRes$data$hikans, _basicRes$data2;
                setInitEntry('reportDate')((0, _moment.default)().format('YYYY/MM/DD'));
                setInitEntry('reportDestNm')((_basicRes$data$hikans = basicRes === null || basicRes === void 0 || (_basicRes$data2 = basicRes.data) === null || _basicRes$data2 === void 0 ? void 0 : _basicRes$data2.hikansaSekinishaNm) !== null && _basicRes$data$hikans !== void 0 ? _basicRes$data$hikans : '');
              }
              if (updRes.data.seijukudoCheckFlg === true) {
                changeComment(updRes.data);
              }
            } else {
              setAnsDataError(true);
              dataErrorMessage();
            }
          } else {
            setAnsDataError(true);
            dataErrorMessage();
          }
        } else {
          const sejRes = await callAPI(_APIs.KANSA_RESULT_SEIJUKUDO, sendDataKekka);
          if (sejRes.status === _APIs.STATUS.SUCCESS) {
            if (sejRes.data !== null) {
              setSeijukudo(sejRes.data.seijukudo);
              setInitEntry('kansabumonComment')(sejRes.data.kansabumonComment);
            } else {
              setAnsDataError(true);
              dataErrorMessage();
            }
          } else {
            setAnsDataError(true);
            dataErrorMessage();
          }
        }
      } catch (e) {
        if ((e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.UNMOUNTED || (e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.CALLING) {
          // no-op
        } else {
          throw e;
        }
      }

      // 初回のみスクロール（登録押下後の再初期化ではスクロールしない）
      if (!scrolledRef.current) {
        window.scrollTo(0, 0);
        scrolledRef.current = true;
      }
      // 初期ロード完了フラグ
      loadedRef.current = true;
    };
    run();
  }, [callAPI, kansaInfo, gyomuCd, setkansaTgtJigyoBasicInfo, setInitEntry, setSeijukudo, setEntries, setDispFlg, upd, changeComment, dataErrorMessage, setFollowupList, setGoodpointList, setkaizenList, setFutekigoList]);
  const shape = (0, _react.useMemo)(() => {
    const s = {};
    Object.keys(listState || {}).forEach(key => {
      s["".concat(key, "_hakkenjiko")] = Yup.string().nullable().max(200, intl.formatMessage({
        id: _labelConsts.LABEL.CORE_LENGTH_MESSAGE
      }, {
        0: 200
      })).test('required-or-not', intl.formatMessage({
        id: _labelConsts.LABEL.CORE_REQUIRED_MESSAGE
      }), function (v) {
        var _this$parent;
        const requires = (_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent["".concat(key, "_requiresHakkenjiko")];
        if (!requires) return true;
        return !!(v && String(v).trim() !== '');
      });
      s["".concat(key, "_requiresHakkenjiko")] = Yup.boolean().nullable();
    });
    s['procKbn'] = Yup.string().oneOf([_kansaResultRegisterActions.PROC_KBN.TMP_SAVE, _kansaResultRegisterActions.PROC_KBN.TMP_SAVE_UPDATE, _kansaResultRegisterActions.PROC_KBN.REGISTER, _kansaResultRegisterActions.PROC_KBN.UPDATE]).required();
    s['shoninDate'] = Yup.string().transform(_validationHelpers.trimToUndefined).nullable().concat((0, _validationHelpers.dateOrEmptyStrict)(intl)).concat((0, _validationHelpers.notFutureDateOrEmpty)(intl)).when('procKbn', (pk, schema) => String(pk) === String(_kansaResultRegisterActions.PROC_KBN.REGISTER) || String(pk) === String(_kansaResultRegisterActions.PROC_KBN.UPDATE) ? schema.required(intl.formatMessage({
      id: _labelConsts.LABEL.CORE_REQUIRED_MESSAGE
    })) : schema);
    s['naibukansaJissiDt'] = Yup.string().transform(_validationHelpers.trimToUndefined).nullable().when('procKbn', {
      is: pk => pk === _kansaResultRegisterActions.PROC_KBN.REGISTER || pk === _kansaResultRegisterActions.PROC_KBN.UPDATE,
      then: ss => ss.required(intl.formatMessage({
        id: _labelConsts.LABEL.CORE_REQUIRED_MESSAGE
      })),
      otherwise: ss => ss
    }).test('valid-or-empty-datetime', intl.formatMessage({
      id: _labelConsts.LABEL.CORE_INVALID_DATETIME_MESSAGE
    }), val => !val || val !== 'invalid').test('not-future-datetime', intl.formatMessage({
      id: _labelConsts.LABEL.CORE_UNABLE_ENTER_FUTURE_DATE
    }), val => {
      if (!val || val === 'invalid') return true;
      const m = (0, _moment.default)(val, 'YYYY/MM/DD HH:mm', true);
      if (!m.isValid()) return true;
      return !m.isAfter((0, _moment.default)());
    });
    // 登録／更新時のみ必須
    s['sogohyoka'] = (0, _validationHelpers.requiredSelectWhen)(intl, ['procKbn'], pk => pk === _kansaResultRegisterActions.PROC_KBN.REGISTER || pk === _kansaResultRegisterActions.PROC_KBN.UPDATE);
    s['naibukansaJissiPlace'] = (0, _validationHelpers.optionalStringTrimMax)(intl, 200);
    s['sokatsu'] = (0, _validationHelpers.requiredStringTrimMaxWhen)(intl, ['procKbn'], pk => pk === _kansaResultRegisterActions.PROC_KBN.REGISTER || pk === _kansaResultRegisterActions.PROC_KBN.UPDATE, 500);
    s['kansabumonComment'] = (0, _validationHelpers.optionalStringTrimMax)(intl, 5000);
    s['shoninshaNm'] = (0, _validationHelpers.requiredStringTrimMaxWhen)(intl, ['procKbn'], pk => pk === _kansaResultRegisterActions.PROC_KBN.REGISTER || pk === _kansaResultRegisterActions.PROC_KBN.UPDATE, 60);
    return s;
  }, [listState, intl]);
  const {
    handleSubmit,
    setValue,
    formState,
    reset,
    register
  } = (0, _useRHFForm.useRHFForm)({
    defaultValues: (0, _react.useMemo)(() => {
      var _entries$shoninDate, _entries$naibukansaJi, _entries$sogohyoka, _entries$naibukansaJi2, _entries$sokatsu, _entries$kansabumonCo, _entries$shoninshaNm;
      const dv = {};
      Object.keys(listState || {}).forEach(key => {
        var _listState$key$hakken, _listState$key, _listState$key2;
        dv["".concat(key, "_hakkenjiko")] = (_listState$key$hakken = (_listState$key = listState[key]) === null || _listState$key === void 0 ? void 0 : _listState$key.hakkenjiko) !== null && _listState$key$hakken !== void 0 ? _listState$key$hakken : '';
        const bunrui = (_listState$key2 = listState[key]) === null || _listState$key2 === void 0 ? void 0 : _listState$key2.hakkenjikoBunruiCd;
        const requires = (procKbn === _kansaResultRegisterActions.PROC_KBN.REGISTER || procKbn === _kansaResultRegisterActions.PROC_KBN.UPDATE) && bunrui !== null && bunrui !== _CodeConsts.CODE.KANSA_HKN_BNR.CODE_0;
        dv["".concat(key, "_requiresHakkenjiko")] = requires;
      });
      dv['procKbn'] = procKbn;
      dv['shoninDate'] = (_entries$shoninDate = entries === null || entries === void 0 ? void 0 : entries.shoninDate) !== null && _entries$shoninDate !== void 0 ? _entries$shoninDate : '';
      dv['naibukansaJissiDt'] = (_entries$naibukansaJi = entries === null || entries === void 0 ? void 0 : entries.naibukansaJissiDt) !== null && _entries$naibukansaJi !== void 0 ? _entries$naibukansaJi : '';
      dv['sogohyoka'] = (_entries$sogohyoka = entries === null || entries === void 0 ? void 0 : entries.sogohyoka) !== null && _entries$sogohyoka !== void 0 ? _entries$sogohyoka : '';
      dv['naibukansaJissiPlace'] = (_entries$naibukansaJi2 = entries === null || entries === void 0 ? void 0 : entries.naibukansaJissiPlace) !== null && _entries$naibukansaJi2 !== void 0 ? _entries$naibukansaJi2 : '';
      dv['sokatsu'] = (_entries$sokatsu = entries === null || entries === void 0 ? void 0 : entries.sokatsu) !== null && _entries$sokatsu !== void 0 ? _entries$sokatsu : '';
      dv['kansabumonComment'] = (_entries$kansabumonCo = entries === null || entries === void 0 ? void 0 : entries.kansabumonComment) !== null && _entries$kansabumonCo !== void 0 ? _entries$kansabumonCo : '';
      dv['shoninshaNm'] = (_entries$shoninshaNm = entries === null || entries === void 0 ? void 0 : entries.shoninshaNm) !== null && _entries$shoninshaNm !== void 0 ? _entries$shoninshaNm : '';
      return dv;
    }, [listState, entries, procKbn]),
    shape
  });
  const {
    errors,
    isDirty
  } = formState;
  (0, _react.useEffect)(() => {
    register('procKbn');
    register('shoninDate');
    register('naibukansaJissiDt');
    register('sogohyoka');
    register('naibukansaJissiPlace');
    register('sokatsu');
    register('kansabumonComment');
    register('shoninshaNm');
    Object.keys(listState || {}).forEach(key => {
      register("".concat(key, "_hakkenjiko"));
      register("".concat(key, "_requiresHakkenjiko"));
    });
  }, [register, listState]);

  // 未編集時はlistState/entries/procKbnの最新値でRHFを同期
  (0, _react.useEffect)(() => {
    var _entries$shoninDate2, _entries$naibukansaJi3, _entries$sogohyoka2, _entries$naibukansaJi4, _entries$sokatsu2, _entries$kansabumonCo2, _entries$shoninshaNm2;
    if (isDirty) return;
    const init = {};
    Object.keys(listState || {}).forEach(key => {
      var _listState$key$hakken2, _listState$key3, _listState$key4;
      init["".concat(key, "_hakkenjiko")] = (_listState$key$hakken2 = (_listState$key3 = listState[key]) === null || _listState$key3 === void 0 ? void 0 : _listState$key3.hakkenjiko) !== null && _listState$key$hakken2 !== void 0 ? _listState$key$hakken2 : '';
      const bunrui = (_listState$key4 = listState[key]) === null || _listState$key4 === void 0 ? void 0 : _listState$key4.hakkenjikoBunruiCd;
      const requires = (procKbn === _kansaResultRegisterActions.PROC_KBN.REGISTER || procKbn === _kansaResultRegisterActions.PROC_KBN.UPDATE) && bunrui !== null && bunrui !== _CodeConsts.CODE.KANSA_HKN_BNR.CODE_0;
      init["".concat(key, "_requiresHakkenjiko")] = requires;
    });
    init['procKbn'] = procKbn;
    init['shoninDate'] = (_entries$shoninDate2 = entries === null || entries === void 0 ? void 0 : entries.shoninDate) !== null && _entries$shoninDate2 !== void 0 ? _entries$shoninDate2 : '';
    init['naibukansaJissiDt'] = (_entries$naibukansaJi3 = entries === null || entries === void 0 ? void 0 : entries.naibukansaJissiDt) !== null && _entries$naibukansaJi3 !== void 0 ? _entries$naibukansaJi3 : '';
    init['sogohyoka'] = (_entries$sogohyoka2 = entries === null || entries === void 0 ? void 0 : entries.sogohyoka) !== null && _entries$sogohyoka2 !== void 0 ? _entries$sogohyoka2 : '';
    init['naibukansaJissiPlace'] = (_entries$naibukansaJi4 = entries === null || entries === void 0 ? void 0 : entries.naibukansaJissiPlace) !== null && _entries$naibukansaJi4 !== void 0 ? _entries$naibukansaJi4 : '';
    init['sokatsu'] = (_entries$sokatsu2 = entries === null || entries === void 0 ? void 0 : entries.sokatsu) !== null && _entries$sokatsu2 !== void 0 ? _entries$sokatsu2 : '';
    init['kansabumonComment'] = (_entries$kansabumonCo2 = entries === null || entries === void 0 ? void 0 : entries.kansabumonComment) !== null && _entries$kansabumonCo2 !== void 0 ? _entries$kansabumonCo2 : '';
    init['shoninshaNm'] = (_entries$shoninshaNm2 = entries === null || entries === void 0 ? void 0 : entries.shoninshaNm) !== null && _entries$shoninshaNm2 !== void 0 ? _entries$shoninshaNm2 : '';
    reset(init, {
      keepDirty: false,
      keepErrors: true,
      keepTouched: false
    });
  }, [listState, entries, procKbn, reset, isDirty]);
  (0, _react.useEffect)(() => {
    Object.keys(listState || {}).forEach(key => {
      var _listState$key5, _listState$key$hakken3, _listState$key6;
      const bunrui = (_listState$key5 = listState[key]) === null || _listState$key5 === void 0 ? void 0 : _listState$key5.hakkenjikoBunruiCd;
      const requires = (procKbn === _kansaResultRegisterActions.PROC_KBN.REGISTER || procKbn === _kansaResultRegisterActions.PROC_KBN.UPDATE) && bunrui !== null && bunrui !== _CodeConsts.CODE.KANSA_HKN_BNR.CODE_0;
      setValue("".concat(key, "_hakkenjiko"), (_listState$key$hakken3 = (_listState$key6 = listState[key]) === null || _listState$key6 === void 0 ? void 0 : _listState$key6.hakkenjiko) !== null && _listState$key$hakken3 !== void 0 ? _listState$key$hakken3 : '', {
        shouldValidate: false,
        shouldDirty: false
      });
      setValue("".concat(key, "_requiresHakkenjiko"), requires, {
        shouldValidate: false,
        shouldDirty: false
      });
    });
  }, [listState, procKbn, setValue]);
  const setEntryDirtyForm = (0, _react.useCallback)(key => value => {
    props.setEntry(key)(value);
    setDirty(true);
    setValue(key, value, {
      shouldValidate: false,
      shouldDirty: true
    });
  }, [props, setDirty, setValue]);
  const onChangeBunruiCd = (0, _react.useCallback)(rowKey => val => {
    changeBunruiCd(rowKey)(val);
    const requires = (procKbn === _kansaResultRegisterActions.PROC_KBN.REGISTER || procKbn === _kansaResultRegisterActions.PROC_KBN.UPDATE) && val !== null && val !== _CodeConsts.CODE.KANSA_HKN_BNR.CODE_0;
    setValue("".concat(rowKey, "_requiresHakkenjiko"), requires, {
      shouldValidate: false,
      shouldDirty: true
    });
  }, [changeBunruiCd, procKbn, setValue]);
  const onChangeHakkenjiko = (0, _react.useCallback)(rowKey => val => {
    changeHakkenjiko(rowKey)(val);
    setValue("".concat(rowKey, "_hakkenjiko"), val, {
      shouldValidate: false,
      shouldDirty: true
    });
  }, [changeHakkenjiko, setValue]);

  /**
   * 前年度ボタン押下時処理
   */
  const onClickOverridePreviousEntries = (0, _react.useCallback)(() => {
    let dispContent = '';
    if (zennendoSimpleFlg === _CodeConsts.CODE.FLG_VALUE.CODE_0) {
      // 前年度の簡易版フラグが0の場合は詳細版
      dispContent = _kansaResultActions.CONTENTS.RESULT_REFER_OLD;
    } else if (zennendoSimpleFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
      // 前年度の簡易版フラグが1の場合は簡易版
      dispContent = _kansaResultActions.CONTENTS.RESULT_REFER;
    }
    const params = {
      keyKansaTgtNendo: kansaTgtJigyoBasicInfo.zennendoKansaTgtNendo,
      keyKansaTgtJigyoId: kansaTgtJigyoBasicInfo.zennendoKansaTgtJigyoId,
      keyDispContent: dispContent
    };
    (0, _openSSO.openSubWindowWithParams)('kansa_result', 'kansa_result_entry', '', '', params).focus();
  }, [zennendoSimpleFlg, kansaTgtJigyoBasicInfo]);

  // ボタンクリック時（一時保存（登録・更新）／登録／更新）
  const onButtonClick = (0, _react.useCallback)(pk => {
    setProcKbn(pk);
    setIsCustomCheck(pk === _kansaResultRegisterActions.PROC_KBN.REGISTER || pk === _kansaResultRegisterActions.PROC_KBN.UPDATE);
    setValue('procKbn', pk, {
      shouldValidate: false,
      shouldDirty: true
    });
    Object.keys(listState || {}).forEach(key => {
      var _listState$key7;
      const bunrui = (_listState$key7 = listState[key]) === null || _listState$key7 === void 0 ? void 0 : _listState$key7.hakkenjikoBunruiCd;
      const requires = (pk === _kansaResultRegisterActions.PROC_KBN.REGISTER || pk === _kansaResultRegisterActions.PROC_KBN.UPDATE) && bunrui !== null && bunrui !== _CodeConsts.CODE.KANSA_HKN_BNR.CODE_0;
      setValue("".concat(key, "_requiresHakkenjiko"), requires, {
        shouldValidate: false,
        shouldDirty: true
      });
    });
  }, [listState, setValue]);

  /**
   * 登録・更新実行
   */
  const onRegister = (0, _react.useCallback)(() => {
    const {
      kansaTgtNendo,
      kansaTgtJigyoId
    } = kansaInfo;
    const {
      kansaAnsDt,
      kansakekkaCreDt
    } = kansaTgtJigyoBasicInfo;

    // 前年度フォローアップ
    let followup = [];
    for (let key in listState) {
      if (listState[key].isChange) {
        followup.push({
          kansaTgtNendo: listState[key].kansaTgtNendo,
          kansaTgtJigyoId: listState[key].kansaTgtJigyoId,
          shitekijikoKbnCd: listState[key].shitekijikoKbnCd,
          no: listState[key].no,
          hakkenjikoBunruiCd: listState[key].hakkenjikoBunruiCd,
          hakkenjiko: listState[key].hakkenjiko,
          insert: listState[key].insert
        });
      }
    }
    const sendData = _objectSpread(_objectSpread({}, entries), {}, {
      kansaTgtNendo,
      kansaTgtJigyoId,
      kansaAnsDt,
      kansakekkaCreDt,
      seijukudo,
      followupList: followup,
      goodpointList,
      kaizenList,
      futekigoList,
      gyomuCd,
      pushFlg: mailFlg && gyomuCd === _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_1 && entries.pushFlg,
      procKbn
    });
    if (procKbn !== _kansaResultRegisterActions.PROC_KBN.TMP_SAVE && procKbn !== _kansaResultRegisterActions.PROC_KBN.TMP_SAVE_UPDATE) {
      // 一時保存以外の場合
      // 監査成熟度チェック
      callAPI(_APIs.KANSA_RESULT_SEIJUKUDO_CHECK, sendData).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          if (response.data.seijukudoCheckFlg === true) {
            openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
              id: _labelConsts.LABEL.KANSA_RESULT_SEIJUKUDO_CHECK_REGIST
            }));
          } else {
            // 登録・更新処理
            callAPI(_APIs.KANSA_RESULT_REGISTER, sendData).then(resp => {
              if (resp.status === _APIs.STATUS.SUCCESS) {
                setRegisterDt(resp.data.registerDt);
                setContent(_kansaResultRegisterActions.CONTENTS_REG.RESULT);
                setMailErrMsg(resp.message);
              } else {
                openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, resp.message);
              }
            });
          }
        }
      });
    } else {
      // 一時保存の場合
      const newSendData = _objectSpread(_objectSpread({}, sendData), {}, {
        pushFlg: false
      });
      // 登録・更新処理
      callAPI(_APIs.KANSA_RESULT_REGISTER_TEMPSAVE, newSendData).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          setRegisterDt(response.data.registerDt);
          if (isProgress) {
            // 監査進捗状況の検索結果一覧からの遷移の場合
            goProgressMain(true);
          } else {
            // 監査結果の検索結果一覧からの遷移の場合
            goMain(true);
          }
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.SUCCESS, intl.formatMessage({
            id: _labelConsts.LABEL.KANSA_RESULT_TEMP_SAVE
          }));
        } else {
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
        }
      });
    }
  }, [kansaInfo, kansaTgtJigyoBasicInfo, listState, entries, seijukudo, goodpointList, kaizenList, futekigoList, gyomuCd, mailFlg, procKbn, callAPI, openInfoBar, intl, setRegisterDt, setContent, setMailErrMsg, isProgress, goProgressMain, goMain]);

  // 確認ダイアログ
  const openConfirmDialog = (0, _react.useCallback)(() => {
    const hasError = ansDataError || !seijukudo;
    if (hasError) {
      dataErrorMessage();
      if (!seijukudo) {
        setAnsDataError(true);
      }
      return;
    }
    if (procKbn === _kansaResultRegisterActions.PROC_KBN.TMP_SAVE || procKbn === _kansaResultRegisterActions.PROC_KBN.TMP_SAVE_UPDATE) {
      openConfirm(intl.formatMessage({
        id: _labelConsts.LABEL.CORE_CONFIRM
      }), intl.formatMessage({
        id: _labelConsts.LABEL.CORE_TEMPORARILY_SAVED_CONFIRM_MESSAGE
      }), () => {
        onRegister();
      });
    } else if (procKbn === _kansaResultRegisterActions.PROC_KBN.REGISTER || procKbn === _kansaResultRegisterActions.PROC_KBN.UPDATE) {
      openConfirm(intl.formatMessage({
        id: _labelConsts.LABEL.CORE_CONFIRM
      }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
        id: _labelConsts.LABEL.CORE_REGISTER_CONFIRM_MESSAGE
      }), mailFlg && gyomuCd === _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_1 && entries.pushFlg && intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_SEND_MAIL_CONFIRM
      }, {
        0: intl.formatMessage({
          id: _labelConsts.LABEL.KANSA_HI_KANSA_BUMON
        })
      })), () => {
        onRegister();
      });
    }
  }, [ansDataError, seijukudo, procKbn, openConfirm, intl, mailFlg, gyomuCd, entries, onRegister, dataErrorMessage]);
  const onInvalid = (0, _react.useCallback)(() => {
    openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_VALIDATE_MESSAGE
    }));
  }, [openInfoBar, intl]);

  // pushFlg の変更ハンドラ（event/booleanの両対応）
  const onChangePushFlg = (0, _react.useCallback)(v => {
    var _v$target;
    const checked = typeof v === 'boolean' ? v : !!(v !== null && v !== void 0 && (_v$target = v.target) !== null && _v$target !== void 0 && _v$target.checked);
    props.setEntry('pushFlg')(checked);
    setValue('pushFlg', checked, {
      shouldValidate: false,
      shouldDirty: true
    });
  }, [props, setValue]);

  // 一時保存ボタン
  const tempSaveButton = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    onClick: () => {
      if (upd) {
        onButtonClick(_kansaResultRegisterActions.PROC_KBN.TMP_SAVE_UPDATE);
      } else {
        onButtonClick(_kansaResultRegisterActions.PROC_KBN.TMP_SAVE);
      }
    },
    submit: true
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_RESULT_TEMPORARILY_STORE
  }));

  // 登録／更新ボタン
  const registerUpdateButton = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    onClick: () => {
      if (upd) {
        onButtonClick(_kansaResultRegisterActions.PROC_KBN.UPDATE);
      } else {
        onButtonClick(_kansaResultRegisterActions.PROC_KBN.REGISTER);
      }
    },
    submit: true
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_REGISTER
  }));

  // ボタン生成
  const onlyReturnButton = [returnBtn()];
  const withTempButton = [returnBtn(), tempSaveButton, registerUpdateButton];
  const noTempButton = [returnBtn(), registerUpdateButton];
  const getErrorsForFollowupKey = (0, _react.useCallback)(key => {
    var _errors;
    return {
      hakkenjiko: (_errors = errors["".concat(key, "_hakkenjiko")]) === null || _errors === void 0 ? void 0 : _errors.message
    };
  }, [errors]);
  return /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit(() => openConfirmDialog(), onInvalid)
  }, /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_REGISTER_TITLE
    }),
    actions: ansDataError ? onlyReturnButton : dispFlg === true ? withTempButton : noTempButton,
    help: /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
      id: _labelConsts.LABEL.KANSA_RESULT_REGISTER_HELP
    })
  }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 1.5
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 8
    },
    align: "left"
  }, (() => {
    // 当年度の監査対象基本情報.簡易版フラグが簡易版の場合、かつ、前年度の監査結果作成状況コードが作成済みの場合
    if (kansaTgtJigyoBasicInfo && kansaTgtJigyoBasicInfo.simpleFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1 && zennendoKansakekkaCreStsCd === _CodeConsts.CODE.KANSA_RSLT_STS.CODE_3) {
      return /*#__PURE__*/_react.default.createElement(_CButton.default, {
        autoWidth: true,
        onClick: () => {
          onClickOverridePreviousEntries();
          overridePreviousEntries();
        },
        sx: {
          display: 'block',
          m: 0
        }
      }, intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_REFER_ZENNENDO_TITLE
      }));
    }
  })()), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 4
    },
    align: "right",
    sx: {
      mb: '10px'
    }
  }, returnBtn(), "\u3000"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 1,
    component: "div",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_RegisterReportInfo.default, {
    reportDate: entries.reportDate,
    reportDestNm: entries.reportDestNm
  }))), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_KANSA_BUMON
    })
  }), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 1,
    component: "div"
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    },
    align: "left"
  }, /*#__PURE__*/_react.default.createElement(_ShoninDate.default, {
    shoninDate: entries.shoninDate,
    onChange: setEntryDirtyForm('shoninDate'),
    isCustomCheck: isCustomCheck,
    error: !!errors.shoninDate,
    helperText: (_errors$shoninDate = errors.shoninDate) === null || _errors$shoninDate === void 0 ? void 0 : _errors$shoninDate.message
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 6
    },
    align: "left"
  }, /*#__PURE__*/_react.default.createElement(_ShoninshaName.default, {
    shoninshaNm: entries.shoninshaNm,
    onChange: setEntryDirtyForm('shoninshaNm'),
    error: !!errors.shoninshaNm,
    helperText: (_errors$shoninshaNm = errors.shoninshaNm) === null || _errors$shoninshaNm === void 0 ? void 0 : _errors$shoninshaNm.message
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    },
    align: "left"
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_GAIYO
    })
  }), /*#__PURE__*/_react.default.createElement(_KansaTgtJigyoBasicInfo.default, {
    data: typeof kansaTgtJigyoBasicInfo === 'object' && kansaTgtJigyoBasicInfo ? kansaTgtJigyoBasicInfo : {}
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    },
    align: "left"
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_KEKKA_SOKATSU
    })
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 4
    },
    align: "left"
  }, /*#__PURE__*/_react.default.createElement(_SogoHyoka.default, {
    sogohyoka: entries.sogohyoka,
    onChange: setEntryDirtyForm('sogohyoka'),
    error: !!errors.sogohyoka,
    helperText: (_errors$sogohyoka = errors.sogohyoka) === null || _errors$sogohyoka === void 0 ? void 0 : _errors$sogohyoka.message
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    },
    align: "left"
  }, /*#__PURE__*/_react.default.createElement(_KansaKekkaJissiDate.default, {
    naibukansaJissiDt: entries.naibukansaJissiDt,
    onChange: setEntryDirtyForm('naibukansaJissiDt'),
    isCustomCheck: isCustomCheck,
    error: !!errors.naibukansaJissiDt,
    helperText: (_errors$naibukansaJis = errors.naibukansaJissiDt) === null || _errors$naibukansaJis === void 0 ? void 0 : _errors$naibukansaJis.message
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 7
    },
    align: "left"
  }, /*#__PURE__*/_react.default.createElement(_KansaKekkaJissiPlace.default, {
    naibukansaJissiPlace: entries.naibukansaJissiPlace,
    onChange: setEntryDirtyForm('naibukansaJissiPlace'),
    error: !!errors.naibukansaJissiPlace,
    helperText: (_errors$naibukansaJis2 = errors.naibukansaJissiPlace) === null || _errors$naibukansaJis2 === void 0 ? void 0 : _errors$naibukansaJis2.message
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 7
    },
    align: "left"
  }, /*#__PURE__*/_react.default.createElement(_KansaKekkaSokatsu.default, {
    sokatsu: entries.sokatsu,
    onChange: setEntryDirtyForm('sokatsu'),
    error: !!errors.sokatsu,
    helperText: (_errors$sokatsu = errors.sokatsu) === null || _errors$sokatsu === void 0 ? void 0 : _errors$sokatsu.message
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    },
    align: "left"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      paddingTop: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_ZENNENDO_FOLLOWUP
    })
  })), followupList.length !== 0 ? /*#__PURE__*/_react.default.createElement(_FollowupList.default, {
    followupList: followupList,
    listState: listState,
    changeBunruiCd: onChangeBunruiCd,
    changeHakkenjiko: onChangeHakkenjiko,
    getCodeItems: getCodeItems,
    intl: intl,
    errorsForKey: getErrorsForFollowupKey
  }) : /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2",
    sx: {
      color: 'rgb(49, 71, 218)'
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_RESULT_FOLLOWUP_NODATA
  }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    },
    align: "left"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      paddingTop: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_GOODPOINT
    })
  })), goodpointList.length !== 0 ? /*#__PURE__*/_react.default.createElement(_KakuninjikoList.default, {
    list: goodpointList
  }) : /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2",
    sx: {
      color: 'rgb(49, 71, 218)'
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_NODATA
  }, {
    0: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_GOODPOINT
    })
  }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    },
    align: "left"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      paddingTop: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_KAIZEN
    })
  })), kaizenList.length !== 0 ? /*#__PURE__*/_react.default.createElement(_KakuninjikoList.default, {
    list: kaizenList
  }) : /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2",
    sx: {
      color: 'rgb(49, 71, 218)'
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_NODATA
  }, {
    0: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_KAIZEN
    })
  }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    },
    align: "left"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      paddingTop: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_FUTEKIGO
    })
  })), futekigoList.length !== 0 ? /*#__PURE__*/_react.default.createElement(_KakuninjikoList.default, {
    list: futekigoList
  }) : /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2",
    sx: {
      color: 'rgb(49, 71, 218)'
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_NODATA
  }, {
    0: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_FUTEKIGO
    })
  }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    },
    align: "left"
  }, seijukudo.length !== 0 ? /*#__PURE__*/_react.default.createElement(_CRadarChart.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SEJUKUDO_HYOKA
    }),
    chartHeight: 450,
    chartWidth: 650,
    domainMax: maxPoints,
    tickCount: maxPoints + 2,
    radarAttr: [{
      name: getCodeName(_CodeConsts.CODE.KANSA_GYOMU_CD.KBN, _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_1),
      key: 'score',
      color: '#FF0000'
    }],
    chartData: seijukudo,
    dataKey: "chosaColumnNm"
  }) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SEJUKUDO_HYOKA
    })
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2",
    sx: {
      color: 'rgb(49, 71, 218)'
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_RESULT_SEIJUKUDO_NODATA
  })))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 8
    },
    align: "left"
  }, /*#__PURE__*/_react.default.createElement(_SeijukudoComment.default, {
    kansabumonComment: entries.kansabumonComment === null ? '' : entries.kansabumonComment,
    onChange: setEntryDirtyForm('kansabumonComment'),
    error: !!errors.kansabumonComment,
    helperText: (_errors$kansabumonCom = errors.kansabumonComment) === null || _errors$kansabumonCom === void 0 ? void 0 : _errors$kansabumonCom.message
  })), mailFlg && gyomuCd === _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_1 && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 8
    },
    align: "left"
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_PUSH_COMPLETE_REGISTER
    }),
    required: true,
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_PUSH_MAIL
  }, {
    0: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_HI_KANSA_BUMON
    })
  }), /*#__PURE__*/_react.default.createElement(_CSwitch.default, {
    checked: entries.pushFlg,
    onChange: onChangePushFlg,
    required: true,
    shiftLeft: true
  })))))))));
}
const mapStateToProps = (state, ownProps) => {
  var _ownProps$upd;
  return {
    entries: state.kansaResultRegister.entries,
    userInfo: state.kansaResultRegister.userInfo,
    kansaInfo: state.kansaResultRegister.kansaInfo,
    kansaTgtJigyoBasicInfo: state.kansaResultRegister.kansaTgtJigyoBasicInfo,
    followupList: state.kansaResultRegister.followupList,
    goodpointList: state.kansaResultRegister.goodpointList,
    kaizenList: state.kansaResultRegister.kaizenList,
    futekigoList: state.kansaResultRegister.futekigoList,
    seijukudo: state.kansaResultRegister.seijukudo,
    dispFlg: state.kansaResultRegister.dispFlg,
    listState: state.kansaResultRegister.listState,
    mailFlg: state.coreLoginInfo.mailFlg,
    gyomuCd: state.kansaResult.searchConditions.gyomuCd,
    isProgress: state.kansaResult.isProgress,
    upd: (_ownProps$upd = ownProps.upd) !== null && _ownProps$upd !== void 0 ? _ownProps$upd : state.kansaResultRegister.upd
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setEntry: key => value => {
      dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](true));
      dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_ENTRY](key, value));
    },
    setInitEntry: key => value => {
      dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_ENTRY](key, value));
    },
    setEntries: entries => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_ENTRIES](entries)),
    setkansaTgtJigyoBasicInfo: kansaTgtJigyoBasicInfo => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_KANSATGTJIGYOBASICINFO](kansaTgtJigyoBasicInfo)),
    setFollowupList: followupList => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_FOLLOWUPLIST](followupList)),
    setGoodpointList: goodpointList => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_GOODPOINTLIST](goodpointList)),
    setkaizenList: kaizenList => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_KAIZENLIST](kaizenList)),
    setFutekigoList: futekigoList => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_FUTEKIGOLIST](futekigoList)),
    setSeijukudo: seijukudo => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_SEIJUKUDO](seijukudo)),
    setKansaInfo: kansaInfo => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_KANSA_INFO](kansaInfo)),
    setDispFlg: dispFlg => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_DISPFLG](dispFlg)),
    changeBunruiCd: userId => hakkenjikoBunruiCd => {
      dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](true));
      dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.CHANGE_BUNRUICD](userId, hakkenjikoBunruiCd));
    },
    changeHakkenjiko: userId => hakkenjiko => {
      dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](true));
      dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.CHANGE_HAKKENJIKO](userId, hakkenjiko));
    },
    setContent: content => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_CONTENT](content)),
    goMain: search => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.GO_MAIN](search)),
    setRegisterDt: dt => {
      dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](false));
      dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_REGISTER_DT](dt));
    },
    overridePreviousEntries: () => {
      dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](true));
    },
    setMailErrMsg: mailErrMsg => {
      dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_MAIL_ERR_MSG](mailErrMsg));
    },
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk)),
    goProgressMain: search => dispatch(_kansaProgressActions.kansaProgressActions[_kansaProgressActions.TYPES.GO_MAIN](search))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CodeUtil.withCodeUtil)((0, _CallAPI.withCallAPI)(KansaRegisterEntry))));